
<script>
import { layoutMethods,  smsBlastCampaignMethods} from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
// import { smsBlastDashboardData } from "@/views/pages/_version_2_/others/sms_blast/mock_data_dashboard";

export default {
  page: {
    title: "SMS Blast",
  },
  data() {
    return {
      smsBlastDashboardData: [],
      smsBlastDashboardPageData: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      orderBy: "id",
      sort: "DESC",
      sortDesc: true,
      search: {
        keyword: "",
        field: "",
        status: "",
        dateRange: null,
        filter: "",
        filterKeyword: "",
      },
      rangeOptions: {
        mode: "range",
      },
      searchFieldOptions: [
        { text: "All", value: "" },
        { text: "Campaign Name", value: "campaign_name" },
      ],
      filterByOptions: [
        { text: "All", value: "" },
        { text: "Sent", value: "sent" },
        { text: "Failed", value: "failed" },
        { text: "Pending", value: "pending" },
        { text: "Draft", value: "draft" },
      ],
      fields: [
        { key: "action", sortable: false },
        { key: "campaign_name", label: "Campaign Name", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "schedule_date", label: "Scheduled Date", sortable: true },
        { key: "total_recipients", label: "Total Recipient", sortable: true },
        { key: "sent_count", label: "Sent", sortable: true },
        { key: "failed_count", label: "Failed", sortable: true },
      ],
      filterDescription: "",
      showFilterInput: false,
    };
  },
  components: {
    flatPickr,
  },
  computed: {
  },
  methods: {
    ...layoutMethods,
    ...smsBlastCampaignMethods,
    async getSMSBlastListsData() {
      let params = {
        page: this.currentPage,
        rows: this.perPage,
        sort: this.sort,
        orderBy: this.orderBy,
        search: this.search,
      };

      // Add your API call here
      await this.actionSMSBlastAPIPOST({
          params: params,
          action: 'list'
        }).then((res) => {
          // console.log("SMS Campaigns res:", res);
          const {status, message} = res;
          if(status != 'ok'){
            console.error("Error fetching SMS Campaigns:", message);
            return;
          }
          this.smsBlastDashboardData = message?.rows ?? [];
          this.smsBlastDashboardPageData = message?.pageInfo ?? { total: 0, currentPage: 1, nextPage: 0, prevPage: 0};
        }).catch((err) => {
          console.error("Error fetching SMS Campaign:", err);
          return;
        }); 
    },
    async deleteSMSBlast(id) {
      // console.log("Deleting SMS Campaign id:", id);
      if(!id) return;
      await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to delete this campaign? This process cannot be undone.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.actionSMSBlastAPIPOST({
            params: { id },
            action: 'delete'
          }).then(async (res) => {
            // console.log("Delete SMS Campaign res:", res);
            const {status, message} = res;
            if(status != 'ok'){
              console.error("Error deleting SMS Campaign:", message);
              return;
            }
            const successConfig = {
              title: "Delete Successful",
              text: `${message} has been deleted.`,
              icon: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#e73092"
            };
            await Swal.fire(successConfig);
            this.getSMSBlastListsData();
          }).catch((err) => {
            console.error("Error deleting SMS Campaign:", err);
            return;
          }); 
        }
      });
    },
    setStatus(data) {
      return data.status;
    },
    async sortList(action) {
      this.orderBy = action.sortBy;
      this.sort = action.sortDesc ? "DESC" : "ASC";
      await this.getSMSBlastListsData();
    },
    setFilter() {
      switch (this.search.filter) {
        case "start_date":
          this.filterDescription = "Filter by Start Date";
          this.showFilterInput = true;
          break;
        case "end_date":
          this.search.filterKeyword = "";
          this.filterDescription = "Filter by End Date";
          this.showFilterInput = true;
          break;
        default:
          this.showFilterInput = false;
          break;
      }
    },
  },
  async mounted() {
    this.changeTitle({ title: "SMS Blast" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Notification", to: { name: "" } },
        { text: "SMS Blast", to: { name: "SMS Blast Campaign" } },
      ],
    });

    await this.getSMSBlastListsData();
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <!-- #region Request and Refresh buttons -->
      <div class="d-flex align-items-center py-2">
        <div>
          <h5>{{ smsBlastDashboardPageData.total }} Record(s)</h5>
        </div>
        <div class="ms-auto">
          <router-link :to="`/others/smsblast/campaign/0`">
            <button class="btn btn-primary me-2 mb-2"><i class="uil uil-plus me-1"></i>Add SMS Campaign</button>
          </router-link>
          <button class="btn btn-secondary mb-2" @click="getSMSBlastListsData()">
            <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
          </button>
        </div>
      </div>
      <!-- #endregion Request and Refresh buttons -->

      <!-- #region Search and Filter -->
      <div class="row p-2">
        <div class="col-md-4 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Search Keyword">
              <form class="d-flex" @submit.prevent="">
                <b-form-group id="input-group-3" label-for="search-field">
                  <b-form-select
                    style="width: fit-content"
                    class="form-select rounded-0 rounded-start shadow-none"
                    id="search-field"
                    v-model="search.field"
                    :options="searchFieldOptions"
                  ></b-form-select>
                </b-form-group>

                <b-input-group>
                  <b-form-input class="rounded-0 rounded-end" v-model="search.keyword"></b-form-input>
                </b-input-group>
              </form>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 p-0">
          <div class="ta-right me-2">
            <b-form-group description="Filter by">
              <b-form-select
                class="form-select rounded shadow-none dd-custom-size"
                v-model="search.filter"
                :options="filterByOptions"
                @input="setFilter"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-2 col-sm-12 p-0" v-if="showFilterInput">
          <div class="ta-right me-2">
            <b-form-group :description="filterDescription" class="me-2 w-daterange">
              <b-form-select
                v-if="search.filter == 'provider'"
                class="form-select rounded-0 rounded-start shadow-none w-100"
                v-model="search.filterKeyword"
                :options="providerOptions"
              ></b-form-select>
              <b-form-select
                v-else-if="search.filter == 'network'"
                class="form-select rounded-0 rounded-start shadow-none w-100"
                v-model="search.filterKeyword"
                :options="networkOptions"
              ></b-form-select>
              <b-form-select
                v-else-if="search.filter == 'network_group'"
                class="form-select rounded-0 rounded-start shadow-none w-100"
                v-model="search.filterKeyword"
                :options="networkGroupOptions"
              ></b-form-select>
              <flat-pickr
                v-else-if="search.filter == 'start_date'"
                v-model="search.dateRange"
                :config="rangeOptions"
                placeholder="Select a date range"
                class="form-control"
              ></flat-pickr>
              <flat-pickr
                v-else-if="search.filter == 'end_date'"
                v-model="search.dateRange"
                :config="rangeOptions"
                placeholder="Select a date range"
                class="form-control"
              ></flat-pickr>
            </b-form-group>
          </div>
        </div>

        <div class="col-md-4 col-sm-12 d-flex">
          <div class="me-2">
            <b-button
              variant="primary"
              class="h-fit d-flex align-items-center justify-content-center me-2 w-fit"
              @click="getSMSBlastListsData"
            >
              <i class="bx bx-search me-1 mt-1"></i>Search
            </b-button>
          </div>
          <!-- <div class="">
            <b-button
              variant="primary"
              class="h-fit me-2 d-flex align-items-center justify-content-center w-fit"
              @click="
                isSearching = true;
                onExport();
              "
            >
              <i class="uil uil-export me-1"></i>
              Export
            </b-button>
          </div> -->
        </div>
      </div>
      <!-- #endregion Search and Filter -->

      <!-- #region Table -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="smsBlastDashboardData"
            :fields="fields"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="orderBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="sortList"
            tbody-tr-class="align-middle"
          >
            <template #cell(action)="data">
              <div v-if="data.item.is_draft">
                <router-link :to="`/others/smsblast/campaign/${data.item.id}`">
                  <button type="button" class="btn btn-sm btn-primary p-1">
                    <i class="bx bx-edit bx-xs bx-fw"></i>
                  </button>
                </router-link>
                <button type="button" class="btn btn-sm btn-danger mx-2" @click="deleteSMSBlast(data.item.id)">
                  <i class="bx bx-trash-alt"></i>
                </button>
              </div>
            </template>

            <template #cell(campaign_name)="data">
              <router-link :to="data.item.is_draft ? `/others/smsblast/campaign/${data.item.id}` : `/others/smsblast/campaign/view/${data.item.id}`">
                <div class="text-primary">{{ data.item.campaign_name }}</div>
              </router-link>
            </template>

            <template #cell(schedule_date)="data"> 
              <div>{{ data.item.schedule_date | customFormatDate}}</div>
            </template>

            <template #cell(status)="data">
              <div
                :class="{
                  'text-warning fw-semibold': setStatus(data.item) == 'Pending',
                  'text-success fw-semibold': setStatus(data.item) == 'Sent',
                  'text-danger fw-semibold': setStatus(data.item) == 'Failed',
                }"
              >
                {{ setStatus(data.item) }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row g-0 text-center" v-if="smsBlastDashboardPageData.total == 0">
        <span>No data to display.</span>
      </div>
      <!-- #endregion Table -->

      <!-- #region Pagination -->
      <div class="row g-0 text-center text-sm-start" v-if="smsBlastDashboardPageData.total > 10">
        <div class="col-sm-12">
          <div class="row">
            <div class="col">
              <div class="form-group row pull-left">
                <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                <div class="col-sm-6">
                  <b-form-group label-for="display-record">
                    <b-form-select
                      class="form-select shadow-none w-fit"
                      id="display-record"
                      v-model="perPage"
                      :options="pageOptions"
                      @change="getSMSBlastListsData()"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-end" v-if="smsBlastDashboardPageData.total > perPage">
                <b-pagination
                  class="pagination-rounded"
                  v-model="currentPage"
                  @input="getSMSBlastListsData()"
                  :total-rows="smsBlastDashboardPageData.total"
                  :per-page="perPage"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- #endregion Pagination -->
    </div>
  </div>
</template>


<style scoped>
.disabled {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
}
</style>
